function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

function Svg165SintMaarten(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.006 512.006",
    style: {
      enableBackground: "new 0 0 512.006 512.006"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0.003,
    y: 0.017,
    style: {
      fill: "#0052B4"
    },
    width: 512,
    height: 511.989
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "512.003,0 512.003,250.031 0.003,256.258 0.003,0 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "256.003,256.008 0.003,512 0.003,0 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDA44"
    },
    d: "M44.815,256.001c-0.144,1.888-0.24,3.789-0.24,5.713c0,41.027,33.259,74.287,74.287,74.287   c41.027,0,74.286-33.259,74.286-74.287c0-1.924-0.097-3.826-0.242-5.713H44.815z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFDA44"
    },
    cx: 118.865,
    cy: 198.856,
    r: 22.857
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D80027"
    },
    d: "M67.432,193.142v74.287c0,39.367,51.429,51.429,51.429,51.429s51.429-12.061,51.429-51.429v-74.287  H67.432z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#338AF3"
    },
    d: "M118.886,294.936c-9.54-3.433-28.596-12.209-28.596-27.508v-51.429h57.144v51.429  C147.432,282.776,128.379,291.531,118.886,294.936z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F3F3F3"
    },
    points: "130.289,244.571 130.289,233.143 118.86,227.428 107.433,233.143 107.433,244.571   101.718,250.286 101.718,273.142 136.003,273.142 136.003,250.286 "
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg165SintMaarten);
export default "data:image/svg+xml;base64,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";
export { ForwardRef as ReactComponent };